// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"0c47481a","418":"52eb8cb1","668":"05a8a82e","708":"eb13c239","739":"06dafe49","974":"020cfbe5"}[chunkId] + ".js";
};